import Oidc from 'oidc-client'
import commonJs from './common'


const saasHost = process.env.SAAS_HOST;//saas网站首页
const saasAuth = process.env.SAAS_AUTH;//saas登录
// const saasHost = 'http://localhost:9001/'//saas网站首页

var config = {
  automaticSilentRenew:true,
  authority: saasAuth,
  client_id: "saas-js-client",
  clockSkew: 1800,//默认是5分钟，修改为30分钟
  redirect_uri: saasHost+"callback",
  silent_redirect_uri: saasHost+"callback",
  response_type: "code",
  client_secret: "secret",
  scope:"openid profile offline_access developerService",
  post_logout_redirect_uri: saasHost
};
console.log(commonJs)
var mgr = new Oidc.UserManager(config);


const utils = {
  // 登录
  login() {
    mgr.signinRedirect();
    mgr.getUser().then(function (user) {
      if(user){
        commonJs.setLocalstorage("accessToken",user.access_token)
        // localStorage["accessToken"] = user.access_token;
      }
    });
  },
  login404(){
    location.href = saasHost+"notFound";
  },
  // 登出
  loginOut() {
    mgr.signoutRedirect()
    localStorage.removeItem('accessToken');
    localStorage.removeItem('toSaaSWhere');
    sessionStorage.clear()
  },
}
export default {
  utils,
  config
};
window.login401 = utils.login;
window.login404 = utils.login404;




// WEBPACK FOOTER //
// ./src/public/oidcRoot.js